export default __webpack_public_path__ + "static/media/pos2.220900d8.gif";